// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"a067763b","431":"23afb63c","507":"1b615d4f"}[chunkId] + ".chunk.js";
};